module.exports = __webpack_public_path__ + "img/collection-weddingRingsMorningGlow.365ccd2.webp";